import { render, staticRenderFns } from "./TopicalLoading.vue?vue&type=template&id=31a58acb&scoped=true&lang=pug&"
import script from "./TopicalLoading.vue?vue&type=script&lang=ts&"
export * from "./TopicalLoading.vue?vue&type=script&lang=ts&"
import style0 from "./TopicalLoading.vue?vue&type=style&index=0&id=31a58acb&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a58acb",
  null
  
)

export default component.exports